import { render, staticRenderFns } from "./usersGrupo.vue?vue&type=template&id=c6a6ccba"
import script from "./usersGrupo.vue?vue&type=script&lang=js"
export * from "./usersGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports